"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ENDPOINTS_1 = __importDefault(require("../../../constants/app/ENDPOINTS"));
const http_service_1 = __importDefault(require("../../../services/http.service"));
const formatURLWithQueryParam_1 = __importDefault(require("../../../utils/http/formatURLWithQueryParam"));
/**
 * Client interface to get a dropoff charges
 * @param {DropoffChargesParamType} dropoffQuery
 * @returns Promise
 */
const getDropoffCharges = (dropoffQuery) => {
    const requestId = 'DROP_OFF_CHARGES';
    const endPoint = (0, formatURLWithQueryParam_1.default)(`${ENDPOINTS_1.default.TARIFF_SERVICE.DROP_OFF_CHARGES}`, dropoffQuery);
    return http_service_1.default.get(requestId, endPoint).then((response) => response.data);
};
exports.default = getDropoffCharges;
